import { Link } from "react-router-dom";

export const Logo = ({ className = "", onClick, height = 30 }) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="navbar-logo-link"
      className={`inline-flex items-center ${className}`}
      aria-label="Sentira home"
    >
      <img
        src="/brand/logo-white.png"
        alt="Sentira"
        style={{ height: `${height}px` }}
        className="w-auto select-none"
        draggable="false"
      />
    </Link>
  );
};

export default Logo;
